export default __webpack_public_path__ + "static/media/logo.9f87c487.svg";